export default "__VITE_ASSET__Dm2tQRO8__"